import { render, staticRenderFns } from "./PuntoDeVentaUbicacionDetalles.vue?vue&type=template&id=0b280ad1"
import script from "./PuntoDeVentaUbicacionDetalles.vue?vue&type=script&lang=js"
export * from "./PuntoDeVentaUbicacionDetalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports